/**
 * @generated SignedSource<<d9693f036224b1a4186e44fbc76be933>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type moduleRatingDetailsChart_Query$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  nodeRef: string;
};
export type moduleRatingDetailsChart_Query$data = {
  readonly Admin: {
    readonly ModuleRating: {
      readonly ModuleRatingCalculations: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly scoreMap: {
              readonly five: number;
              readonly four: number;
              readonly one: number;
              readonly three: number;
              readonly two: number;
              readonly zero: number;
            };
          };
        } | null | undefined> | null | undefined;
      };
    };
  };
};
export type moduleRatingDetailsChart_Query = {
  response: moduleRatingDetailsChart_Query$data;
  variables: moduleRatingDetailsChart_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nodeRef"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminQueryType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ModuleRatingAdminSchema",
        "kind": "LinkedField",
        "name": "ModuleRating",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "after"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "nodeRef",
                "variableName": "nodeRef"
              }
            ],
            "concreteType": "ModuleRatingCalculationTypesConnection",
            "kind": "LinkedField",
            "name": "ModuleRatingCalculations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ModuleRatingCalculationTypesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ModuleRatingCalculation",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ModuleRatingScoreMap",
                        "kind": "LinkedField",
                        "name": "scoreMap",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "zero",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "one",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "two",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "three",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "four",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "five",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "moduleRatingDetailsChart_Query",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "moduleRatingDetailsChart_Query",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "1332aa3622e96f8468e71c7bc82c2d07",
    "id": null,
    "metadata": {},
    "name": "moduleRatingDetailsChart_Query",
    "operationKind": "query",
    "text": "query moduleRatingDetailsChart_Query(\n  $nodeRef: ID!\n  $first: Int\n  $after: String\n) {\n  Admin {\n    ModuleRating {\n      ModuleRatingCalculations(first: $first, after: $after, nodeRef: $nodeRef) {\n        edges {\n          node {\n            scoreMap {\n              zero\n              one\n              two\n              three\n              four\n              five\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "622bec973dbb4a95181e63cf298e067d";

export default node;
